<template>
  <div id="app">
    <HomePage></HomePage>
  </div>
</template>

<script>
import HomePage from "@/view/HomePage";
export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>

<style scoped lang="scss">
#app {
  overflow: hidden;
}
</style>
